"use strict";

import Bricklayer from 'bricklayer';
import ImagesLoaded from 'imagesloaded';
export default function brickLayerInit() {
    var bricklayerElement = document.getElementById('my-bricklayer');
    if(bricklayerElement) {
        var imgLoad = ImagesLoaded('.bricklayer');
        var bricklayer = new Bricklayer(bricklayerElement);
        imgLoad.on( 'progress', function( instance, image ) {
            bricklayer.redraw();
        });
    }
};


// WEBPACK FOOTER //
// ./components/bricklayerstuffagain.js